import { Injectable } from '@angular/core';
import { BaseApiService } from '@shared/data-access';
import { Observable } from 'rxjs';
import { LoggedInOfficerResponse } from '../models/logged-in-officer.models';

@Injectable({
  providedIn: 'root',
})
export class BaseOfficerService {
  constructor(public api: BaseApiService) {}

  getLoggedInOfficer(): Observable<LoggedInOfficerResponse> {
    return this.api.get<LoggedInOfficerResponse>(`api/profile`);
  }

  changeLoggedInOfficerProfile(checkboxValue: boolean, uid: string): Observable<boolean> {
    return this.api.patch(`api/users/${uid}/profile`, { AutoClearFilters: checkboxValue });
  }
}
